import * as React from 'react'
import { TextField } from '@mui/material';
import { BtcInfoContext } from '../general/SatoshiPriceProvider';


type Props = {
    onChange?: (satoshis: number) => void
    label: string,
    disabled?: boolean,
    value?: number,
}

const SatoshiInput: React.FC<Props> = ({ onChange, label, disabled, value }: Props) => {
    const satoshiPriceContext = React.useContext(BtcInfoContext);
    const [usd, setUsd] = React.useState<string>(null);


    React.useEffect(() => {
        if (!value || !satoshiPriceContext.satoshiUsdPrice) {
            return;
        }
        const price = (value * satoshiPriceContext.satoshiUsdPrice).toFixed(2);
        setUsd(price);
    }, [satoshiPriceContext, value]);

    const disabledColor = disabled? 'text-gray-400': 'text-gray-500';

    return (
        <div className="relative">
            <TextField label={label} type="number" variant="outlined" disabled={disabled}
            className="bg-white"
                value={value}
                style={{width: '100%'}}
            onChange={event => {
                const MAX = 999999999;
                const MIN = 0;
                const value = event.target.value as any as number;

                if (value < MIN) {
                    onChange(MIN);
                } else if (value > MAX) {
                    onChange(MAX);
                } else {
                    onChange(value);
                }
                
            }}></TextField>
            {usd &&
            <div className={'absolute top-4 right-4 ' + disabledColor}>${usd}</div>
            }
            
        </div>
        
    );
}

export default SatoshiInput;



